import { render, staticRenderFns } from "./pfAdmin.vue?vue&type=template&id=63971c14&scoped=true&"
import script from "./pfAdmin.vue?vue&type=script&lang=js&"
export * from "./pfAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63971c14",
  null
  
)

export default component.exports